module.exports = __webpack_public_path__ + "static/img/WechatPrompt_2.46ca576f.png";